import { Cloudinary } from '@cloudinary/url-gen'

export const useCloudinary = () => {
  return new Cloudinary({
    cloud: {
      cloudName: 'helloskin',
    },
  })
}
